import React, { PureComponent } from 'react'
import Analytics from '@lib/Analytics'
import Config from '@lib/Config'
import { UsersABConfigType } from '@lib/ApiClient'
import { compileAnalyticsEventProps } from '@lib/analytics-event-props'
import { ABConfigsStore } from '@store/ab-configs'
import { Popup } from '@components/Popup'
import { CallNowPopup } from '.'

type Props = {
  callHours?: string
  onRequestCall: () => void
  phoneMapping: PhoneMapping
  isShowingSelectedProductPopup: () => boolean
}

type State = {
  autoCallNowPopupVariant: number | null
  showAutoCallNowPopup: boolean
}

export class AutoCallNowPopup extends PureComponent<Props> {
  state: State = {
    autoCallNowPopupVariant: null,
    showAutoCallNowPopup: false,
  }

  private autoPopupTimeout: NodeJS.Timeout

  componentDidMount() {
    if (!this.isEnabled()) {
      return
    }

    const promise = ABConfigsStore.getConfigs()
    this.setupAutoCallNowPopup(promise)
  }

  componentWillUnmount() {
    this.autoPopupTimeout && clearTimeout(this.autoPopupTimeout)
  }

  isEnabled = () => Config.utm_medium !== 'self-service'

  setupAutoCallNowPopup = (promise: Promise<UsersABConfigType>) => {

    promise.then(result => {
      if (!result || result.error) return

      this.setState({ autoCallNowPopupVariant: result.call_now_popup_variant || 0 })
      this.openDelayedCallNowPopup()
    })
  }

  openDelayedCallNowPopup = (delay: number = 120000) => {
    this.autoPopupTimeout = setTimeout(
      this.handleOpenCallNowPopup,
      delay
    )
  }

  handleOpenCallNowPopup = () => {
    if (!Popup.getAmountOfOpenedPopups()) {
      Analytics.log('Showing CallNowPopup', compileAnalyticsEventProps({ variant: this.state.autoCallNowPopupVariant }))
      this.setState({ showAutoCallNowPopup: true })
    } else {
      this.openDelayedCallNowPopup(5000)
    }
  }

  handleCloseCallNowPopup = () => this.setState({ showAutoCallNowPopup: false })

  render() {
    const {
      phoneMapping,
      callHours,
      onRequestCall,
      isShowingSelectedProductPopup
    } = this.props
    const { showAutoCallNowPopup, autoCallNowPopupVariant } = this.state
    const isShowingSelectProductPopup = isShowingSelectedProductPopup()

    const show = !isShowingSelectProductPopup && autoCallNowPopupVariant && showAutoCallNowPopup

    return show && (
      <CallNowPopup
        phoneMapping={phoneMapping}
        onClose={this.handleCloseCallNowPopup}
        onRequestCall={onRequestCall}
        variant={autoCallNowPopupVariant || 0}
        callHours={callHours}
      />
    )
  }
}
